document.addEventListener('DOMContentLoaded', function () {
  const headerMenu = document.querySelector('header-menu');
  if (!headerMenu) return;

  let closeTimer = null;

  const originalPointerLeave = headerMenu.deactivate?.bind(headerMenu);

  Object.defineProperty(headerMenu, 'deactivate', {
    value: function (event) {
      closeTimer = setTimeout(() => {
        if (originalPointerLeave) originalPointerLeave(event);
      }, 400);
    },
    writable: true,
    configurable: true
  });

  headerMenu.addEventListener('pointerenter', function () {
    clearTimeout(closeTimer);
  }, true);
});
